import { configureStore } from "@reduxjs/toolkit";
import resourceReducer from "./slices/resourceSlice";
import uiReducer from "./slices/uiSlice";
import userReducer from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    resource: resourceReducer,
    user: userReducer,
    ui: uiReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
